import React from "react";
import { Form, Dropdown } from "semantic-ui-react";
import { useIntl } from "react-intl";
import styles from "./ProductSection.module.scss";

type Props = {
    title: string;
    checkboxType: string;
    categoryTypes: string[];
    onChange: (e: string, type: any) => void;
    data: any;
};

const ProductSection: React.FunctionComponent<Props> = ({
    title,
    categoryTypes,
    checkboxType,
    onChange,
    data,
}) => {
    const intl = useIntl();

    const dropdownOptions = categoryTypes.map((c: string) => ({
        key: c,
        text: intl.formatMessage({
            id: `categories.${checkboxType}.${c.toLowerCase()}`,
            defaultMessage: c.charAt(0).toUpperCase() + c.slice(1),
        }),
        value: c,
    }));

    const handleDropdownChange = (_e: any, { value }: any) => {
        // Clear existing selections and add new ones
        data.forEach((item: string) => {
            if (!value.includes(item)) {
                onChange(item, checkboxType);
            }
        });
        value.forEach((item: string) => {
            if (!data.includes(item)) {
                onChange(item, checkboxType);
            }
        });
    };

    return (
        <div className={styles.section}>
            <h4 className={styles.title}>{title}</h4>
            <Form.Group grouped name={checkboxType}>
                <Dropdown
                    placeholder={`Select ${title.toLowerCase()}`}
                    fluid
                    multiple
                    selection
                    options={dropdownOptions}
                    value={data}
                    onChange={handleDropdownChange}
                    className={styles.dropdown}
                />
            </Form.Group>
        </div>
    );
};

export default ProductSection;
